
(() => {
  const selectors = [
    ".product__text-container-AVE53KzIwL2xhNVcrc__text_with_icon_z7hk9G",
    ".product__text-container-AK0lIT1U1YUNoYk9YY__text_with_icon_6GCe6n"
  ];

  function fitBenefits() {
    
if (window.matchMedia("(max-width: 1100px)").matches) {
  document.querySelectorAll(selectors.join(","))
    .forEach(block => {
      block.style.removeProperty("--selene-benefit-size");
    });
  return;
}

    const blocks = selectors
      .map(selector => document.querySelector(selector))
      .filter(Boolean);

    if (blocks.length !== 2) return;

    const labels = blocks.flatMap(block =>
      [...block.querySelectorAll(".product__text .text")]
    );

    // Reset both blocks before measuring.
    blocks.forEach(block => {
      block.style.removeProperty("--selene-benefit-size");
    });

    let size = 13;
    const minimum = 9;

    while (size >= minimum) {
      blocks.forEach(block => {
        block.style.setProperty(
          "--selene-benefit-size",
          size + "px"
        );
      });

      const allFit = labels.every(label => {
        const item = label.closest(".product__text");
        if (!item) return true;

        const icon = item.querySelector(".material-icon");
        const iconWidth = icon
          ? icon.getBoundingClientRect().width
          : 0;

        const itemWidth = item.getBoundingClientRect().width;
        const textWidth = label.scrollWidth;

        return textWidth + iconWidth + 8 <= itemWidth + 1;
      });

      if (allFit) break;
      size -= 0.5;
    }
  }

  let frame;

  function scheduleFit() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitBenefits);
  }

  window.addEventListener("resize", scheduleFit);
  document.addEventListener(
    "shopify:section:load", scheduleFit
  );

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded", scheduleFit
    );
  } else {
    scheduleFit();
  }

  document.fonts?.ready.then(scheduleFit);
})();
